import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { BlueBox } from 'src/components';

import { ROUTE } from 'src/constants/routes';

import './investYourself.scss';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const InvestYourself = () => {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const onNavigate = useCallback(
    (to) => () => {
      navigate(to?.replace(':language', i18n?.language));
    },
    [i18n?.language, navigate],
  );

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="invest-yourself">
      <div className={`invest-yourself-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <BlueBox
          supertitle={t('investYourself:supertitle')}
          blackUnderlineTitle={t('investYourself:make')}
          whiteTitle={t('investYourself:ideas')}
          subtitle={t('investYourself:subtitle')}
          buttonTitle={t('title:createAccount')}
          onClick={onNavigate(ROUTE.AUTH.SIGNUP)}
          images="other"
        />
      </div>
    </div>
  );
};
